import React from "react";

class AddMonitor extends React.Component {
    render() {
        const add = this.props.add;
        return(
            <React.Fragment>
                <form className="form" id="add-monitor">
                    <input type="text" className="input" id="monitor-name" placeholder="Client Name" />
                    <input type="text" className="input" id="monitor-url" placeholder="https://clientdomain.example" />
                    <input type="button" onClick={add} value="Add Monitor" />
                </form>
                <div id="add-monitor-error"></div>
            </React.Fragment>
        )
    }
}

class DeleteMonitor extends React.Component {
    render() {
        const update = this.props.update;
        const monitor = this.props.monitor;
        
        return(
            <div className="delete-monitor">
                <i className="fas fa-sync icon" onClick={() => update(monitor.id, "resetMonitor")}></i>
                <i className="far fa-trash-alt icon" onClick={() => update(monitor.id, "deleteMonitor")}></i>
            </div>
        )
    }
}

export { AddMonitor, DeleteMonitor }


// WEBPACK FOOTER //
// ./src/component_uptime/components/MonitorControls.js